import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Heading from "~components/atoms/heading/heading";
import ButtonLeadingIcon from "~components/molecules/button/button_components/button_leading_icon/button_leading_icon";
import ButtonTrailingIcon from "~components/molecules/button/button_components/button_trailing_icon/button_trailing_icon";
import LinkWrapper from "~components/utils/link_wrapper/link_wrapper";
import { LINK } from "../../../../../prop_types";
import {
  buttonStyle,
  isActiveStyle,
  isDisabledStyle,
  nextButtonStyle,
  wrapperStyle,
} from "./prev_next_button.module.scss";

function PrevNextButton({ link, type, description, title }) {
  const [isActive, setIsActive] = useState(false);

  return (
    <div
      className={wrapperStyle}
      onMouseEnter={() => {
        setIsActive(true);
      }}
      onFocus={() => {
        setIsActive(true);
      }}
      onMouseLeave={() => {
        setIsActive(false);
      }}
      onBlur={() => {
        setIsActive(false);
      }}
    >
      <LinkWrapper link={link} isDisabled={!link}>
        <div
          className={classNames(
            buttonStyle,
            { [nextButtonStyle]: type === "Next" },
            { [isDisabledStyle]: !link },
            { [isActiveStyle]: isActive }
          )}
        >
          {type === "Previous" && (
            <ButtonLeadingIcon
              isActive={isActive}
              icon="icon_chevron_left"
              iconSize={32}
            />
          )}
          <div>
            <Heading visualLevel={4} marginBottom={0}>
              {title}
            </Heading>
            {description && (
              <Heading
                visualLevel={6}
                marginTop={8}
                marginBottom={0}
                isBaseFontWeight
              >
                {description}
              </Heading>
            )}
          </div>
          {type === "Next" && (
            <ButtonTrailingIcon
              isActive={isActive}
              icon="icon_chevron_right"
              iconSize={32}
            />
          )}
        </div>
      </LinkWrapper>
    </div>
  );
}

PrevNextButton.propTypes = {
  link: LINK,
  type: PropTypes.oneOf(["Previous", "Next"]).isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

PrevNextButton.defaultProps = {
  link: null,
};

export default PrevNextButton;
